import { Stack } from '@backyard-ui/core';

import { type Distribution } from '@/infra/services/catalog/review/model';

import Item from './components/Item';
import { formatDistribution } from './utils';

export interface RatingResumeProps {
  distribution: Distribution[];
  totalReviewsCount: number;
  size: 'sm' | 'md';
}

export default function RatingResume(props: RatingResumeProps) {
  const { distribution: rawDistribution, size, totalReviewsCount } = props;

  const distribution = formatDistribution(rawDistribution);

  return (
    <Stack spacing="2" direction="column" data-testid="rating-resume">
      {distribution.map(({ value, count }) => (
        <Item
          key={value}
          value={value}
          count={count}
          totalReviewsCount={totalReviewsCount}
          size={size}
        />
      ))}
    </Stack>
  );
}
